import React from "react";
import { Button, Modal } from "semantic-ui-react";
import SubscriptionManagement from "./SubscriptionManagement";

type SubscriptionsModalProps = {
  /** Function to run on modal close. */
  onModalClose?: (...args: any[]) => void;
};

/**
 * Subscriptions modal wrapper.
 */
class SubscriptionsModal extends React.PureComponent<SubscriptionsModalProps> {
  state = { open: true };
  closeModal = () => this.setState({ open: false });
  render() {
    return (
      <Modal
        dimmer="blurring"
        open={this.state.open}
        onClose={() => {
          this.props.onModalClose?.();
          this.closeModal();
        }}
        size="tiny"
        className="section-modal"
      >
        <Modal.Header>Manage Subscription and Limits</Modal.Header>
        <Modal.Content>
          <SubscriptionManagement />
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={() => this.closeModal()}>
            Done
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default SubscriptionsModal;
